import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { basicAlert } from '../../utils';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ClienteService } from 'src/app/services/cliente.service';

@Component({
  selector: 'app-modal-direccion-envio-ubigeo',
  templateUrl: './modal-direccion-envio-ubigeo.component.html',
  styleUrls: ['./modal-direccion-envio-ubigeo.component.css']
})
export class ModalDireccionEnvioUbigeoComponent implements OnInit {

  listaclases: any[] = []
  listaprovincias: any[] = []
  listadistritos: any[] = []
  codigoUbigeo: any;
  codDist: any;
  codProv: any;
  codDepart: any;

  public desDepartamento: string = '';
  public desProvincia: string = '';
  public desDistrito: string = '';



  disabledprov: boolean = true;
  disableddistr: boolean = true;
  constructor(
    private modalactiveService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private clienteService: ClienteService,
  ) { }

  ngOnInit(): void {
    this.getDireccionesClasesCodigo(14)
    this.codDepart = '00'
  }

  _close() {
    this.modalactiveService.dismiss('canceling');
  }

  _ok() {

    let clasesUbigeo: any[] = [];

    let ubi1 = {};
    let ubi2 = {};
    let ubi3 = {};


    this.listaclases.forEach(element => {
      if (element.codigo == this.codDepart) {
        this.desDepartamento = element.descri;
      }
    });

    this.listaprovincias.forEach(element => {
      if (element.codigo == this.codProv) {
        this.desProvincia = element.provincia;
      }
    });

    this.listadistritos.forEach(element => {
      if (element.codigo == this.codDist) {
        this.desDistrito = element.distrito;
      }
    });

    ubi1 = {
      clase: 14,
      desclase: 'DEPARTAMENTO',
      codigo: this.codDepart,
      descodigo: this.desDepartamento
    }

    ubi2 = {
      clase: 15,
      desclase: 'PROVINCIA',
      codigo: this.codProv,
      descodigo: this.desProvincia
    }

    ubi3 = {
      clase: 16,
      desclase: 'DISTRITO',
      codigo: this.codDist,
      descodigo: this.desDistrito
    }

    clasesUbigeo.push(ubi1);
    clasesUbigeo.push(ubi2);
    clasesUbigeo.push(ubi3);


    this.modalactiveService.close(clasesUbigeo);


  }

  onChangeDepartamento(valor: any) {
    console.log(valor);
    this.spinnerService.activarLoading(true);
    this.clienteService.get_direcciones_envio_clases_ubigeo(valor).subscribe((resp: any) => {
      console.log(resp)
      this.listaprovincias = resp.body.provincias
      this.codProv = this.listaprovincias[0].codigo
      this.listadistritos = this.listaprovincias[0].distritos
      this.codDist = this.listaprovincias[0].distritos[0].codigo

      this.disabledprov = false;
      this.disableddistr = false;
      this.spinnerService.activarLoading(false);

    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }

  onChangeProvincia(valor: any) {
    console.log(valor);
    this.spinnerService.activarLoading(true);

    this.listaprovincias.forEach(element => {
      if (element.codigo == valor) {
        this.listadistritos = element.distritos
        this.codDist = this.listadistritos[0].codigo
      }

      this.spinnerService.activarLoading(false);
    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }

  onChangeDistrito(valor: any) {


    // this.codDistritoX = this.codProvinciaX + codDistrito;
    this.codigoUbigeo = valor;

  }



  getDireccionesClasesCodigo(valor: any) {
    console.log(valor);
    this.spinnerService.activarLoading(true);
    this.clienteService.get_direcciones_envio_clases_codigos(valor).subscribe((resp: any) => {
      console.log(resp)
      this.listaclases = resp.body
      this.listaprovincias = this.listaclases[0].provincias
      this.spinnerService.activarLoading(false);
    }, err => {
      this.spinnerService.activarLoading(false);
    })

  }


  onKeyEnterProvincia(e) {
    if (this.codProv != null) {
      setTimeout(() => {
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurProvincia(e) {
    if (this.codProv != null) {
      if (e.which == 0) {
        if ($('#cboProvincia option:selected').text() == '') {
          //this.codProv = null;
          basicAlert('No existe el código ingresado.', 'warning', 'Aceptar', null, null, null);
          this.codProv = this.listaprovincias[0].codigo
          this.listaprovincias.forEach(element => {
            if (element.codigo == this.codProv) {
              this.listadistritos = element.distritos
              this.codDist = this.listadistritos[0].codigo
            }

            this.spinnerService.activarLoading(false);
          }, err => {
            this.spinnerService.activarLoading(false);
          })
        }
      }
    }
  }

  onKeyEnterDistrito(e) {
    if (this.codDist != null) {
      setTimeout(() => {
        // this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurDistrito(e) {
    if (this.codDist != null) {
      if (e.which == 0) {
        //  this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
        if ($('#cboDistrito option:selected').text() == '') {
          //his.codDist = null;
          basicAlert('No existe el código ingresado.', 'warning', 'Aceptar', null, null, null);
          this.codDist = this.listadistritos[0].codigo
        }
      }
    }
  }

}
